// extracted by mini-css-extract-plugin
export default {"contactsBox":"contacts_contactsBox__yKxAZ","box":"contacts_box__gMA8i"};